export default __webpack_public_path__ + "static/media/communication_whitecard.cd15f74f.svg";